import { Tag } from 'antd';
import React from 'react';
import { testStatuses } from '../helpers/app-status';

const TableStatusTag = ({status}) => {
  return <Tag  bordered="false" color={testStatuses[status].tagColor}>{testStatuses[status].tagText}</Tag>;
};

export default TableStatusTag;